import React, { useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useNavigate } from "react-router-dom";
import SurveyAddAndEditModal from "./modals/SurveyAddAndEditModal";
import { FaEdit, FaEye } from "react-icons/fa";
import {
  useGetCategoryList,
  useGetSurveyList,
  useSurveyConfiguration,
} from "./hook/useSurvey";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { COLORS } from "../../constants/colors";
import { downloadExcelGet } from "../../utils/ExcelDownload";
import { showToast } from "../../utils/toastUtils";
import { BASE_URL } from "../../Api/config";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";

const HeaderContent = (props: any) => {
  const handleFilter = (key: any, selected: any) => {
    props?.setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : selected.id,
    }));
  };

  return (
    <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={props?.orgUnitsList || []}
        onSelect={(e) => handleFilter(props.handleFilterObjectKey, e)}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading={props?.DropdownHeading}
        headingColor="#2e8dd3"
      />
    </div>
  );
};

const SurveyColumns = (
  handleEditSurvey: (row: any) => void,
  handleView: (row: any) => void
) => [
  {
    name: "Name",
    selector: (row: { SurveyName: string }) => row.SurveyName || "-",
    sortable: true,
    wrap: true,
    width: "200px",
  },
  {
    name: "Survey Category",
    selector: (row: { survey_category_name: string }) =>
      row.survey_category_name || "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Multiple",
    selector: (row: { Multiple: boolean | string }) => `${row.Multiple}` || "-",
    minWidth: "120px",
    sortable: true,
  },
  {
    name: "Status",
    selector: (row: { Status: string }) => row.Status || "-",
    sortable: true,
  },
  {
    name: "Start Date",
    selector: (row: { StartDate: string }) => row.StartDate || "-",
    minWidth: "130px",
    sortable: true,
  },
  {
    name: "End Date",
    selector: (row: { EndDate: string }) => row.EndDate || "-",
    width: "140px",
    sortable: true,
  },
  {
    name: "Audience Type",
    selector: (row: { AudienceType: string }) => row.AudienceType || "-",
    width: "150px",
    sortable: true,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center" style={{}}>
        <div className="d-flex align-items-center">
          <button
            onClick={() => handleEditSurvey(row)}
            className="btn btn-primary"
            style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
          >
            <FaEdit style={{ fill: "#fff" }} /> Edit
          </button>
        </div>
        <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
          <button
            onClick={() => handleView(row)}
            className="btn btn-primary"
            style={{
              borderRadius: "20px",
              padding: "2px",
              width: "70px",
              backgroundColor: "#2e8dd3",
            }}
          >
            <FaEye style={{ fill: "#fff" }} /> View
          </button>
        </div>
      </div>
    ),
    width: "200px",
  },
];

const Survey = () => {
  const { startPolling, stopPolling } = useExcelPolling();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>("");
  const [Surveyrow, setSurveyRow] = useState();

  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
  const [excelLoaing, setExcelLoading] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string>("Loading...");
  const [filterData, setfilterData] = useState({
    page: 1,
    limit: 10,
    search: "",
    Audience_type: "",
    Status: "",
    Category: "",
  });

  const { data, isLoading, isSuccess } = useGetSurveyList({
    enable: true,
    params: {
      page: filterData.page,
      limit: filterData.limit,
      ...(filterData.search == "" ? {} : { search: filterData.search }),
      ...(filterData.Audience_type == "" || filterData.Audience_type == "All"
        ? {}
        : { audienceType: filterData.Audience_type }),
      ...(filterData.Status === "" || filterData.Status === "All"
        ? {}
        : { status: filterData.Status }),
      ...(filterData.Category == ""
        ? {}
        : { surveyCatid: filterData.Category }),
    },
  });

  const {
    data: surveyConfig,
    isLoading: SurveyConfigIsLoading,
    isSuccess: SurveConfigIsSuccess,
  } = useSurveyConfiguration({ enable: true });
  const formatedAudienceTypeData = [
    { id: "All", label: "All" },
    ...(surveyConfig?.formatedData || []),
  ];
  const formatedStatusData = [
    { id: "All", label: "All" },
    ...(surveyConfig?.formatedData_SurveyStatus || []),
  ];
  const {
    data: CategoryList,
    isLoading: CategoryListLoading,
    isSuccess: CategoryListIsSuccess,
  } = useGetCategoryList({ enable: true });

  const handlePagination = (pageNo: number) => {
    setfilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };

  const handleonChangeRowsPerPage = (newPerPage: any, page: any) => {
    setfilterData((prev: any) => ({
      ...prev,
      limit: newPerPage,
      page: page,
    }));
  };
  const handleEditSurvey = (row: any) => {
    setCheckAddEditStatus("Edit");
    setIsModalOpen(true);
    setSurveyRow(row);
  };
  const handleView = (row: any) => {
    navigate("/surveyQuestions", { state: row });
  };
  const toggleModal = () => {
    setCheckAddEditStatus("Add");
    setIsModalOpen(true);
  };

  const handleSearch = (val: any) => {
    setfilterData((prev: any) => ({
      ...prev,
      search: val,
    }));
  };

  const downloadExcelGet = async () => {
    const params: Record<string, any> = {
      ...(filterData.search == "" ? {} : { search: filterData.search }),
      ...(filterData.Category == ""
        ? {}
        : { surveyCatid: filterData.Category }),
      ...(filterData.Status === "" || filterData.Status === "All"
        ? {}
        : { status: filterData.Status }),
      ...(filterData.Audience_type == "" || filterData.Audience_type == "All"
        ? {}
        : { audienceType: filterData.Audience_type }),
    };

    const queryString = new URLSearchParams(params).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.SURVEY.GET_EXCEL_DOWNLOAD}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } =
        response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Survey"
        buttons={[
          {
            label: "+ Add Survey",
            onClick: toggleModal,
            color: COLORS.primary,
          },
          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        paginationTotalRows={
          data?.rowData?.data?.pagination?.total_records || 0
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="Surveys List"
        columns={SurveyColumns(handleEditSurvey, handleView)}
        data={(!isLoading && isSuccess && data?.formatedData) || []}
        headerContent={
          <>
            <HeaderContent
              orgUnitsList={
                (!SurveyConfigIsLoading && formatedAudienceTypeData) || []
              }
              setFiltersState={setfilterData}
              DropdownHeading="Audience Type"
              handleFilterObjectKey="Audience_type"
            />

            <HeaderContent
              orgUnitsList={
                (!SurveyConfigIsLoading && formatedStatusData) || []
              }
              setFiltersState={setfilterData}
              DropdownHeading="Status"
              handleFilterObjectKey="Status"
            />

            <HeaderContent
              orgUnitsList={
                (!CategoryListLoading &&
                  CategoryListIsSuccess &&
                  CategoryList?.formateData) ||
                []
              }
              setFiltersState={setfilterData}
              DropdownHeading="Category"
              handleFilterObjectKey="Category"
            />
          </>
        }
      />

      <SurveyAddAndEditModal
        setCheckAddEditStatus={setCheckAddEditStatus}
        checkAddEditStatus={checkAddEditStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        Surveyrow={Surveyrow}
        title={checkAddEditStatus == "Add" ? "Add Survey" : "Edit Survey"}
      />
    </div>
  );
};

export default Survey;
